import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <Container>
        {/* Page Title */}
        <h2>
          <FontAwesomeIcon className="page-title-icon" icon={faInfo} />
          <span className="page-title">About Me</span>
        </h2>
        {/* End Page Title */}
        {/* Page Content */}
          <Row>
              <Col sm={4}>
                  <img className="about-img" src="/pmtsh_lana.png" alt="Lana in the PMTSH"/>
              </Col>
              <Col sm={8}>
                  <div className="about-content">
                      <p>Hello and welcome to my stylist website!</p>
                      <p>My name is Lana Hill and I'm a professional hairstylist with years of experience in the industry. My passion for hairdressing started several yeas ago, and I've been honing my skills ever since.</p>
                      <p>I specialize in a range of hair care services, including haircuts, coloring, styling, and more. My goal is to help you achieve the look you want and leave you feeling confident and beautiful. I take pride in providing personalized attention to each of my clients and believe that communication is key to achieving your desired outcome.</p>
                      <p>My training and experience have given me the ability to work with a variety of hair types and textures. From fine, straight hair to thick, curly hair, I have the knowledge and expertise to help you achieve a style that works for you.</p>
                      <p>In addition to providing hair care services, I also stay up-to-date with the latest trends and techniques. I believe that ongoing education is essential to providing the best possible service to my clients.</p>
                      <p>Thank you for considering me as your hairstylist. I'm excited to work with you and help you achieve your hair care goals.</p>
                    </div>
              </Col>
          </Row>
        {/* End Page Content */}
      </Container>
    </div>
  );
};

export default AboutPage;